import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import WhyCCA from "@/pages/WhyCCA";
import HowItWorks from "@/pages/HowItWorks";
import Services from "@/pages/Services";
import About from "@/pages/About";
// removed Resources
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Schedule from "@/pages/Schedule";
import Opportunity from "@/pages/Opportunity";
import Leads from "@/pages/Leads";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const TRACK_SKIP = new Set([
  "/leads",
  "/phoenix", "/vegas", "/slc", "/la", "/seattle",
  "/portland", "/sandiego", "/oc", "/sf",
]);

function TrackVisit() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (TRACK_SKIP.has(pathname)) return;
    const key = `cca_tracked_path_${pathname}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: pathname }),
    }).catch(() => {});
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <TrackVisit />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/why-cca" element={<WhyCCA />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/opportunity" element={<Opportunity />} />
              {/* Per-ad short links — each Craigslist ad uses its city URL; the code auto-tracks */}
              <Route path="/phoenix" element={<Navigate to="/opportunity?src=craigslist&code=PH1" replace />} />
              <Route path="/vegas" element={<Navigate to="/opportunity?src=craigslist&code=LV2" replace />} />
              <Route path="/slc" element={<Navigate to="/opportunity?src=craigslist&code=SL3" replace />} />
              <Route path="/la" element={<Navigate to="/opportunity?src=craigslist&code=LA1" replace />} />
              <Route path="/seattle" element={<Navigate to="/opportunity?src=craigslist&code=ST2" replace />} />
              <Route path="/portland" element={<Navigate to="/opportunity?src=craigslist&code=PL3" replace />} />
              <Route path="/sandiego" element={<Navigate to="/opportunity?src=craigslist&code=SD1" replace />} />
              <Route path="/oc" element={<Navigate to="/opportunity?src=craigslist&code=OC2" replace />} />
              <Route path="/sf" element={<Navigate to="/opportunity?src=craigslist&code=SF3" replace />} />
              <Route path="/leads" element={<Leads />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
